import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { castDraft } from 'immer';

import { UserRoleSet } from '@paragon/contract-library';

export interface UserData {
  readonly [email: string]: User;
}

interface UsersState {
  userData: UserData;
}

const initialState: UsersState = {
  userData: {},
};

export interface User {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  roleSet: UserRoleSet;
  permissions: readonly string[];
  organization: string;
  location: string;

  token?: string;
  annotationColor?: string;
}

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    userLoaded: (state, action: PayloadAction<{ readonly loadedUser: User }>) => {
      const { loadedUser } = action.payload;

      state.userData[loadedUser.email] = castDraft(loadedUser);
    },
  },
});

export const { userLoaded } = usersSlice.actions;
export const users = usersSlice.reducer;
